import React from 'react'

const SvgComponent = props => (
  <svg width="1em" height="1em" viewBox="0 0 30 30" {...props}>
    <defs>
      <path id="prefix__b" d="M-617-352H543v579H-617z" />
      <filter
        id="prefix__a"
        width="102.6%"
        height="105.2%"
        x="-1.3%"
        y="-2.6%"
        filterUnits="objectBoundingBox"
      >
        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={5}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <use fill="#000" filter="url(#prefix__a)" xlinkHref="#prefix__b" />
      <use fill="#FFF" xlinkHref="#prefix__b" />
      <path
        d="M25.876 3.416c-2.117-1.844-5.468-1.9-7.62-.092-.99.832-1.88 1.775-2.756 2.724-1.019 1.104-1.492 2.456-1.497 3.951a5.767 5.767 0 0 0 .979 3.279c.107.16.09.246-.041.372a36.2 36.2 0 0 0-1.237 1.24c-.158.167-.265.194-.473.058-2.157-1.403-5.045-1.24-7.015.408-.87.728-1.63 1.576-2.428 2.38-1.498 1.516-2.07 3.348-1.659 5.429.889 4.505 6.185 6.308 9.647 3.49.912-.742 1.695-1.63 2.517-2.468 1.304-1.33 1.829-2.949 1.68-4.792a3.533 3.533 0 0 0-.206-.984c-.59.59-1.148 1.15-1.709 1.709-.066.065-.074.141-.082.226-.077.76-.317 1.462-.792 2.07-.468.6-1.044 1.1-1.574 1.641-.374.382-.733.783-1.16 1.104-1.722 1.295-3.983 1.075-5.44-.518-1.23-1.345-1.35-3.532-.236-4.982.707-.921 1.598-1.674 2.415-2.496.175-.177.37-.335.578-.476 1.248-.849 3.062-.91 4.232-.138-.028.094-.11.143-.173.207-.801.803-1.604 1.603-2.404 2.407a1.913 1.913 0 0 0-.257.305.992.992 0 0 0 .276 1.35c.435.296.94.22 1.373-.211 3.267-3.266 6.533-6.532 9.798-9.8a1.77 1.77 0 0 0 .238-.287.98.98 0 0 0-.103-1.18c-.417-.457-1.036-.461-1.503.001-.83.822-1.653 1.65-2.476 2.477-.063.064-.1.156-.163.255-.079-.118-.108-.158-.132-.201-.772-1.352-.546-3.335.506-4.483a47.126 47.126 0 0 1 2.128-2.15c1.462-1.406 3.35-1.63 5.017-.632 2.068 1.24 2.511 4.247.888 6.02-.694.757-1.435 1.465-2.163 2.186a3.905 3.905 0 0 1-2.513 1.15.382.382 0 0 0-.255.132c-.512.515-1.025 1.026-1.537 1.54-.037.038-.103.065-.073.157.626.16 1.263.228 1.917.188 1.271-.08 2.415-.502 3.383-1.324.98-.83 1.865-1.766 2.739-2.705.89-.956 1.377-2.124 1.47-3.426.148-2.043-.55-3.757-2.104-5.11"
        fill="#999"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgComponent
